'use strict';

var ConfigurationHostShareDirective = function ConfigurationHostShareDirective($rootScope) {
  return {
    restrict: 'E',
    controller: 'ConfigurationHostShareController',
    template: require('../templates/configuration-host-share.html')
  };
};
ConfigurationHostShareDirective.$inject = ['$rootScope'];
module.exports = ConfigurationHostShareDirective;